var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videos"},[_vm._m(0),_c('div',{staticClass:"videos__body"},[_c('Video')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videos__header"},[_c('h1',{staticClass:"videos__header_title",attrs:{"align":"center"}},[_vm._v("Videos")])])
}]

export { render, staticRenderFns }